import React, { useState, useEffect } from "react";

const SearchInput = ({ onSearch, onReset }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [hasForbiddenChars, setHasForbiddenChars] = useState(false);

  useEffect(() => {
    setSearchTerm(onReset);
  }, [onReset]);

  const handleSearch = () => {
    if (!hasForbiddenChars) {
      onSearch(searchTerm.trim());
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    const re = /[\\/:*?<>|]/g;
    if (re.test(value)) {
      setHasForbiddenChars(true);
    } else {
      setHasForbiddenChars(false);
    }
  };

  return (
    <>
      <div className="st-search-box flex-grow-1">
        <img
          src="/documents/d/surekhatech/search"
          alt="search-icon"
          width="24"
          height="24"
          loading="lazy"
          onClick={handleSearch}
        />
        <input
          type="text"
          name="search"
          placeholder="Search"
          className="st-search-input"
          value={searchTerm}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />
      </div>
      {hasForbiddenChars && (
        <div className="st-error-message-item">
          <img
            src="/documents/d/surekhatech/warning"
            alt="warning"
            className="st-error-warning-icon"
            width="20"
            height="20"
            loading="lazy"
          />
          A file name can’t contain any of the following Characters: \/:*?&lt;
          &gt;|
          <button
            className="st-error-close-btn"
            onClick={() => setHasForbiddenChars(false)}
          >
            <img
              src="/documents/d/surekhatech/clear"
              alt="close"
              width="20"
              height="20"
              loading="lazy"
            />
          </button>
        </div>
      )}
    </>
  );
};

export default SearchInput;
